import React, { useEffect, useState } from 'react';
import { useRouter } from 'expo-router';
import { StyleSheet } from 'react-native-unistyles';
import { emojiReactions } from '../../utils/ReactionHelpers';
import Animated, { Easing, useAnimatedStyle, useSharedValue, withSequence, withTiming } from 'react-native-reanimated';
import { TouchableOpacity, Platform } from 'react-native';
import { impactLight, impactMedium } from '../../utils/haptic';
import { useMemo } from 'react';
import { Query } from '../../utils/react-query/Queries';
import { LegendList } from "@legendapp/list";
import ProfileCard from '../People/ProfileCard';
import SheetModal from '../General/SheetModal';
import { Tooltip } from '../General/Tooltip';


const Reaction = ({emojiName, people, onPress = () => {}}) => {
    const [reactionsModalOpen, setReactionsModalOpen] = useState(false);

    const router = useRouter();

    const { data: loggedInUser } = Query.people.loggedInUser()

    const safePeople = people?.filter(Boolean) ?? []

    const emoji = emojiReactions[emojiName];
    const currentUserIncluded = useMemo(() => safePeople.some(person => person.id === loggedInUser?.id), [safePeople.length])

    //Web tooltip: newline-separated list of reactor names
    const tooltipTitle = Platform.OS === 'web'
        ? safePeople.map(p => `${p?.firstName || ''} ${p?.lastName || ''}`.trim()).filter(Boolean).join('\n')
        : null;

    const bounce = useSharedValue(1);
    const rotate = useSharedValue(0);
    const bouceAnimation = useAnimatedStyle(() => ({
        transform: [{scale: bounce.value}, {rotate: rotate.value + "deg"}]
    }))

    useEffect(() => {
        bounce.value = withSequence(withTiming(1.7, {duration: 100}), withTiming(1, {duration: 300, easing: Easing.elastic(2)}))
        rotate.value = withSequence(withTiming(20, {duration: 100}), withTiming(0, {duration: 300, easing: Easing.elastic(2)}));
    }, [safePeople.length])

    const pill = (
        <TouchableOpacity
            testID="reaction-pill"
            hitSlop={10}
            style={styles.container(currentUserIncluded)}
            onPress={() => {
                impactLight()
                onPress();
            }}
            onLongPress={async () => {
                impactMedium()
                setReactionsModalOpen(true)
            }}
        >
            <Animated.Text style={[bouceAnimation, styles.emoji]}>{emoji}</Animated.Text>
            <Animated.Text style={styles.count(currentUserIncluded)}>{safePeople.length}</Animated.Text>
        </TouchableOpacity>
    );

    return (
        <>
            {Platform.OS === 'web' && tooltipTitle
                ? <Tooltip title={tooltipTitle}>{pill}</Tooltip>
                : pill
            }

            <SheetModal isOpen={reactionsModalOpen} onClose={() => setReactionsModalOpen(false)} title={emoji + " Reactions"} snapPoints={[400]}>
                <LegendList recycleItems keyExtractor={(item) => item.id}
                    data={safePeople}
                    estimatedItemSize={50}
                    renderItem={({item}) => <ProfileCard onPress={() => {
                        router.push('/people/' + item?.id)
                        setReactionsModalOpen(false)
                    }} profile={item} minimal />}
                    keyboardShouldPersistTaps="handled"
                />
            </SheetModal>
        </>
      )
}

const styles = StyleSheet.create(theme => ({
    container: (currentUserIncluded) => ({
        backgroundColor: currentUserIncluded ? theme.colors.primaryContainer : theme.colors.surfaceVariant,
        borderRadius: 100,
        borderWidth: 0,
        flexDirection: "row",
        alignItems: "center",
        paddingVertical: 4,
        paddingHorizontal: 8,
        marginHorizontal: 2,
        marginVertical: 4,
        _web: { _hover: { backgroundColor: currentUserIncluded ? theme.colors.primaryContainer : theme.colors.hover } },
    }),
    emoji: {
        fontSize: 13
    },
    count: (currentUserIncluded) => ({
        color: currentUserIncluded ? theme.colors.primary : theme.colors.textSecondary,
        fontFamily: theme.fonts.heading,
        paddingLeft: 4,
        fontSize: 11
    })
}))

export default React.memo(Reaction)